import React, { useState } from 'react'

import { Container, Row, Col, Button } from 'react-bootstrap'
// import { Link } from 'react-router-dom';

import Questions from './Questions'

import Styles from './FaqScreen.module.scss'

const initialQuestions = [
  {
    sectionTitle: 'General',
    id: 'q1',
    open: true,
    questions: [
      {
        title: 'When does the challenge start/end?',
        answer:
          'The PRVN Challenge starts Thursday 21st of July at 6am EST and ends Sunday 24th of July at 6pm EST. Registration will remain open through the close of the challenge on July 24th. All scores must be submitted by 6pm EST on July 24th th in order to be eligible for leaderboard placement, challenge badge, and potential prizes.',
      },
      {
        title: 'How do I register?',
        answer:
          'Use the “Sign-up” button on the Challenge home page. Registration will remain open until 6pm EST on July 24th. A btwb account is required for participation. Participants may log into an existing btwb account or create a brand new account. All new accounts will come with a 30-day free btwb trial.',
      },
      {
        title: 'Do I need to have a btwb subscription to participate?',
        answer:
          'Participants will need to have a btwb subscription in order to participate in the PRVN Challenge. Existing btwb users with paying individual subscriptions, or subscriptions through their gym, are fine as is. Participants who create brand new btwb accounts during the registration process will be granted a free 30-day btwb trial subscription. The trial subscription will be good for 30 days from the point of registration. New btwb users will be required to set up an individual paying subscription once the free trial expires if they wish to continue to use btwb.',
      },
      {
        title: 'Do I need to be part of a gym on btwb to participate?',
        answer: 'btwb accounts do NOT have to be associated with a specific gym on btwb. You can switch gyms inside of the btwb app via Settings if needed. '
      },
      {
        title: 'Can I switch divisions after registering?',
        answer:
          'Participants will be able to switch divisions after the registration process is completed. They will be able to make the switch from the gear icon in the header of the PRVN Challenges: "Wedgewood" challenge screen located in the btwb app.',
      },
    ]
  },
  {
    sectionTitle: 'btwb',
    id: 'q3',
    open: false,
    questions: [
      {
        title: 'How do I log a result for the PRVN Challenge workouts?',
        answer:
          'Participants will log scores to the workouts from the PRVN Challenge screen in the btwb app. Click on the “Log” button, then follow each of the steps in the process.',

      },
      {
        title: 'Can I edit my result?',
        answer:
          'Yes. Participants can edit their logged score any time before July 24th @ 6pm EST.',

      },
      {
        title: 'How do I attach a video to my result?',
        answer: 'Videos can be attached one of two ways. The first way happens during the score logging process. The final screen will prompt a user to attach a video link. Both YouTube and Vimeo links are acceptable. If a user chooses not to attach a video link while logging, they can always return to the result at a later time to attach the video link. In this case, users can find previously logged results on the PRVN Challenge screen in the app. They can click on "Go to results", then on the "Edit" button for the result to be edited. This will take them back through the logging process in order to attach a video on the final step.'
      },
      {
        title: 'What format does my video have to be in?',
        answer: 'Both YouTube and Vimeo links are acceptable.'
      },
      {
        title: 'What is the latest date/time I can attach a video?',
        answer: 'The deadline to attach a video to a logged challenge result is 6pm EST on July 24th. If a video has not been attached to a challenge result by the end of the challenge window, the submission will be ineligible to receive a leaderboard placing a challenge badge and potential prizes. There are no exceptions.'
      }
    ]
  },
  {
    sectionTitle: 'Videos',
    id: 'q4',
    open: false,
    questions: [
      {
        title: 'Do I need a video?',
        answer:
          'Yes! It\'s to ensure that the people winning have met the requirements of each workout and have provided a legit score. If you are within the Top 3 or place 1st and do not attach a video you will be ineligible to win.',

      },
      {
        title: 'What are the specific video guidelines?',
        answer: 'The barbell & plates should be filmed in a way that allows the loads to be clearly identified. Videos need to be uncut & unedited in order to accurately display the performance. Videos shot with a fisheye lens or similar lens may be rejected, we recommend not using such lenses. The clock or timer must be visible during the entire workout. Phone timers, apps and stopwatches are acceptable as long as they are in frame and clearly visible the entire time. Ensure the athlete has ample space to safely perform all aspects of the workout and all potential obstructions have been removed. <br/><br/>At the start of the video, the athlete should be in frame, state their name and the workout they are performing, along with their division of Rx’d or Intermediate. Next, the barbell & plates should be filmed in a way that allows the loads to be clearly identified. Next, the Pull-Up Bar location should be filmed and finally the climbing rope should be filmed and measured to the set height standard for their division. Keep in mind everything needs to be filmed in one continuous unedited video.<br/><br/>Videos need to be uploaded and attached to your btwb result no later than Monday, July 24th EST 2022 @6pm. Be sure to allow sufficient time to submit your score and attach your video.'
      },
      {
        title: 'What if my videos do NOT meet the requirements?',
        answer: 'In this case your videos would not be able to be validated and therefore you would not be able to earn a placement on the leaderboard.'
      },
      {
        title: 'What visibility settings does my video need?',
        answer: 'Videos uploaded to YouTube or Vimeo need to be made “public” so that the btwb judging team can review the performance. Our team gets a lot of videos set as “private”. In those cases, because our judging team cannot review the performance, submissions are rejected. Please make sure our judging team is able to review your videos.'
      }
    ]
  },
  {
    sectionTitle: 'Judging',
    id: 'q5',
    open: false,
    questions: [
      {
        title: 'Do I need a judge when I do the workout?',
        answer:
          'You won’t need a judge while performing the actual workouts. btwb has their own team of judges that will be reviewing and validating each video after the challenge has officially closed. We recommend, however, having somebody to ensure you meet the standards required.',

      },
      {
        title: 'How will the videos be verified?',
        answer: 'It is required that all participants submit a video of their workout performance. The top 3 participants will receive an email notification from the judging team once their performance has been reviewed. If your performance is assessed a penalty, the details of the penalty will be made available in that email within two weeks of the end of the Challenge. If one of the top 3 athletes\' video is ineligible, btwb will move down to the 4th place finisher to review their video. This is why all participants MUST film & submit a video. '
      },
      {
        title: 'Will penalties be assessed?',
        answer: 'Yes, if necessary, penalties will be assessed on a case by case basis as determined during the video review process.'
      },
      {
        title: 'How does this affect leaderboard placing?',
        answer: 'Any penalties assessed may result in an adjustment to the athlete’s score. This adjustment in score may result in the athlete’s position on the leaderboard shifting. Athletes are only eligible for the leaderboard placement and potential prizes by their score after any penalties have been assessed if necessary. '
      },
      {
        title: 'When/how will I know if any penalties have been assessed?',
        answer: 'If your performance is assessed a penalty you will be informed by email within two weeks of the end of the Challenge.'
      },
      {
        title: 'Can I challenge any assessed penalties?',
        answer: 'No. All assessed penalties will be final.'
      },
      {
        title: 'When can I expect my score to be validated?',
        answer: 'Scores should be validated within 10 days of the end of the Challenge.'
      }
    ]
  },
]

const FaqScreen = () => {
  const [questions, setQuestions] = useState(initialQuestions)

  const toggleQuestion = (id) => {
    setQuestions((prev) => {
      const idx = prev.findIndex((item) => item.id === id)
      const updatedQuestion = { ...prev.find((item) => item.id === id) }
      updatedQuestion.open = !updatedQuestion.open
      return [...prev.slice(0, idx), updatedQuestion, ...prev.slice(idx + 1)]
    })
  }

  return (
    <Container>
      <Row>
        <Col className={Styles.faq}>
          <h2>Frequently asked questions</h2>
          <Questions questions={questions} onToggle={toggleQuestion} />
          <div className={Styles.contact}>
            <h2>Do you still have questions?</h2>
            <h3>Feel free to reach out with any questions you might have. We're here to help. </h3>
            <a href={'mailto:support@btwb.com'}>
              <Button variant='primary' className={Styles.btn}>
                Contact us
              </Button>
            </a>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default FaqScreen
